import { AfterViewInit, Component, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AddressBookTypes } from 'src/app/core/classes/address-book-list.parameter';
import { AddressBookParameter } from 'src/app/core/classes/address-book.parameter';
import { AddressBookTypeEnum, AddressBookTypeLabelMapping } from 'src/app/core/interfaces/address-book-response';

@Component({
  selector: 'app-address-book-save',
  templateUrl: './address-book-save.component.html',
  styleUrls: ['./address-book-save.component.scss']
})

export class AddressBookSaveComponent implements AfterViewInit {

    form: FormGroup;  
    @Input() data: AddressBookParameter | null = null;
  
    constructor(
      private fb: FormBuilder) {
  
      this.form = this.fb.group({
        Name: new FormControl(null, Validators.required),
        Shared: new FormControl(null),
        Enabled: new FormControl(false),
        Type: new FormControl(false, Validators.required)
      });
  
    }
  
    ngAfterViewInit() {
  
      this.setup();
  
    }
  
    async setup() {
  
      if (!this.data) return;

      this.form.patchValue(<any>this.data);
  
    }

      protected readonly AddressBookTypeLabelMapping = AddressBookTypeLabelMapping;
      protected readonly AddressBookType = AddressBookTypes;
    
  
  }

export interface AddressBookSaveForm {

  Name: string | null;
  Shared: boolean;
  Enabled: boolean;
  Type?: AddressBookTypeEnum | null;

}